import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-grades-router',
  templateUrl: './grades-router.component.html',
  styleUrls: ['./grades-router.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradesRouterComponent {}
